import { render, staticRenderFns } from "./LayoutCustomerSelectTwo.vue?vue&type=template&id=ca00d242&scoped=true"
import script from "./LayoutCustomerSelectTwo.vue?vue&type=script&lang=js"
export * from "./LayoutCustomerSelectTwo.vue?vue&type=script&lang=js"
import style0 from "./LayoutCustomerSelectTwo.vue?vue&type=style&index=0&id=ca00d242&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca00d242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca00d242')) {
      api.createRecord('ca00d242', component.options)
    } else {
      api.reload('ca00d242', component.options)
    }
    module.hot.accept("./LayoutCustomerSelectTwo.vue?vue&type=template&id=ca00d242&scoped=true", function () {
      api.rerender('ca00d242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/LayoutCustomerSelectTwo.vue"
export default component.exports